import {
  getFirebaseAuthRecaptchaVerifier,
  sendOTPToPhoneForSignIn,
} from "@/helpers/firebase/auth";
import { validatePhoneNumber } from "@/helpers/utils/utility-functions";
import { RecaptchaVerifier, ConfirmationResult } from "firebase/auth";
import React, { useEffect, useState } from "react";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import Button from "../Button/Button";
import { auth } from "@/helpers/firebase/firebase";
import "react-phone-input-2/lib/style.css";

type LoginViaPhonePropType = {
  changeLoginMethod: () => void;
  optRequested: (otpConfirmationResponse: ConfirmationResult, phone: string) => void;
};

interface CustomWindow extends Window {
  recaptchaVerifier: RecaptchaVerifier;
  confirmationResult: ConfirmationResult;
}

declare var window: CustomWindow;

export default function LoginViaPhone({
  changeLoginMethod,
  optRequested,
}: LoginViaPhonePropType) {
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [isOptRequested, setIsOptRequested] = useState<boolean>(false);

  const placeholderText = "(234) 567-8910";

  useEffect(() => {
    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = getFirebaseAuthRecaptchaVerifier()
    }
  }, [auth]);

  const handleLogIn = (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (
      phoneNumber &&
      phoneNumber.length > 0 &&
      validatePhoneNumber(phoneNumber)
    ) {
      sendOtp();
      setIsOptRequested(true);
    }
  };

  const resetRecaptcha = () => {
    if (window.recaptchaVerifier) {
      window.recaptchaVerifier.clear();
      window.recaptchaVerifier = getFirebaseAuthRecaptchaVerifier()
    }
  };

  const sendOtp = async () => {
    const mobileNumber = phoneNumber.startsWith("+")
      ? `${phoneNumber}`
      : `+${phoneNumber}`;
    setPhoneNumber(mobileNumber);
    resetRecaptcha()

    const appVerifier = window.recaptchaVerifier;
    await appVerifier.verify();

    const response = await sendOTPToPhoneForSignIn(mobileNumber, appVerifier);
    if (response) {
      optRequested(response, mobileNumber);
    }
  };

  const phoneNotValidMessage = (
    <div className="flex justify-start items-center">
      <img
        className="h-13 w-25 mt-2"
        src="/images/error_icon.svg"
        alt="c-tribe"
      />
      <p className="mt-2 ml-2 text-[#CD0A0A] font-medium text-sm leading-5">
        Please provide a valid Phone Number.
      </p>
    </div>
  );

  const submitButtonClasses = `w-full h-9 font-bold text-sm leading-5 p-2 rounded-full mb-6 mt-2 hover:bg-white hover:text-black hover:border hover:border-gray-300 
  ${!isOptRequested && !validatePhoneNumber(phoneNumber)
      ? "bg-button-disabled-color bg-opacity-70 cursor-not-allowed text-[#616161]"
      : "bg-button-enabled-color cursor-allowed text-white"
    }`;

  return (
    <>
      <form onSubmit={handleLogIn}>
        <div className="py-4">
          <div className="flex justify-between items-center mt-2">
            <p className="mx-0 text-left font-normal text-sm leading-5 text-custom-gray">
              Phone Number
            </p>
            <div className="flex items-center mb-1.5">
              <button
                type="button"
                onClick={changeLoginMethod}
                className="w-full p-0  hover:text-blue-500 "
              >
                <div className="flex justify-start items-center mt-1.5 hover:underline">
                  <img
                    className="h-5 w-5"
                    src="/images/email_icon.svg"
                    alt="c-tribe"
                  />
                  <p className="ml-1 mb-0 text-left font-medium text-sm leading-5 text-custom-gray">
                    Use Email
                  </p>
                </div>
              </button>
            </div>
          </div>
          <div className="w-full">
            <PhoneInput
              country={"ca"}
              preferredCountries={["ca", "us", "uk"]}
              enableSearch={true}
              containerClass="w-full"
              inputClass="shadow-sm md:bg-gray-500 bg-input-bg-color border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-black-600 focus:border-black-600 block w-full p-2"
              dropdownClass="w-full text-left text-black"
              placeholder={placeholderText}
              value={phoneNumber}
              onChange={(val) => {
                setPhoneNumber(val);
              }}
              inputProps={{
                required: true,
                autoFocus: true,
              }}
              inputStyle={{ width: 320 }}
            />

            {phoneNumber &&
              phoneNumber.length > 0 &&
              !validatePhoneNumber(phoneNumber) &&
              phoneNotValidMessage}
          </div>
        </div>


        <Button
          type="submit"
          data-testid="submit"
          label="CONTINUE WITH PHONE"
          disabled={!validatePhoneNumber(phoneNumber)}
          className={submitButtonClasses}
          width="100%"
        >

        </Button>

      </form>
    </>
  );
}
